import { BankRule, ConnectPlaidAccountsReq } from '../utils/types/bank.type';
import { ApiClient, ClientType } from './apiClient/ApiClient';
import { ServiceType } from './apiClient/config';

const apiClient = () => {
  return ApiClient.Client(ClientType.NotCached, ServiceType.Apiv2);
};

export const getPlaidLinkToken = async () => {
  return await apiClient().get<any>(`banks/bank-integrations`);
};

export const connectPlaidAccounts = async (payload: ConnectPlaidAccountsReq) =>
  await apiClient().post<ConnectPlaidAccountsReq>(
    `banks/bank-integration`,
    payload
  );

export const getBanks = async (fundId?: string) => {
  return fundId
    ? await apiClient().get<any>(`banks/bank-accounts?fundId=${fundId}`)
    : await apiClient().get<any>(`banks/bank-accounts`);
};

export const getBankTransactionsSearch = async (payload: any) => {
  //Set up payload type
  return await apiClient().get<any>(`banks/bank-integrations/search`, payload);
};

export const getBankRules = async (fundId?: string) => {
  return fundId
    ? await apiClient().get<any>(`banks/bank-rules?fundId=${fundId}`)
    : await apiClient().get<any>(`banks/bank-rules`);
};

export const createNewBankRule = async (data: BankRule) =>
  await apiClient().post<BankRule>(`banks/bank-rules`, data);

export const updateBankRule = async (id: string, data: BankRule) =>
  await apiClient().put<BankRule>(`banks/bank-rule/${id}`, data);

export const deleteBankRule = async (id: string) =>
  await apiClient().delete(`banks/bank-rules/${id}`);
